import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Box, Stack, Typography } from "@mui/material";
import {
  Resources,
  getResourcePath,
  useResource,
} from "Translations/Resources";
import { UnstyledLink } from "Components/Routes/UnstyledLink";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Trans } from "react-i18next";
import { NotRecommendedBadge } from "Components/Shared/BanksList/BankButton/Components/NotRecommendedBadge";
import { StarRating } from "Components/Shared/BanksList/BankButton/Components/StarRating";
import { useSortedBanks } from "Hooks/useSortedBanks";

const RESOURCES = Resources.BankRating;

export const BankConnectionRankingPageContent = () => {
  const { t } = useResource();

  return (
    <PrimaryPaper>
      <Stack gap={4}>
        <Typography>
          <Trans
            i18nKey={getResourcePath(RESOURCES.Description)}
            components={{
              linebreak: (
                <>
                  <br />
                  <br />
                </>
              ),
            }}
          />
        </Typography>
        <Typography>
          {t(RESOURCES.ContactUs.PreText)}{" "}
          <UnstyledLink to={`mailto:${t(RESOURCES.ContactUs.Email)}`}>
            {t(RESOURCES.ContactUs.Email)}
          </UnstyledLink>
          . {t(RESOURCES.ContactUs.PostText)}
        </Typography>
      </Stack>
      <BankRatingLink />
    </PrimaryPaper>
  );
};

const BankRatingLink = () => {
  const { t, exists } = useResource();
  const sortedBanks = useSortedBanks();

  return (
    <Stack gap={5} mt={4} width="100%">
      {sortedBanks.map((bank) => {
        const isNotRecommended = exists(
          RESOURCES.Banks[bank].NotRecommended?.Reason,
        );

        if (!isNotRecommended && t(RESOURCES.Banks[bank].Rating) === "") {
          return null;
        }

        const rating = Number(t(RESOURCES.Banks[bank].Rating)) || 0;

        return (
          <UnstyledLink to={`/bank-connection-ranking/${bank}`} key={bank}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={1}
              width="100%"
            >
              <Stack>
                <Typography variant="h6" key={bank} color="text.primary">
                  {t(Resources.BankNames[bank])}
                </Typography>
                {isNotRecommended ? (
                  <NotRecommendedBadge />
                ) : (
                  <StarRating rating={rating} />
                )}
              </Stack>
              <ArrowForwardIcon />
            </Box>
          </UnstyledLink>
        );
      })}
    </Stack>
  );
};
